import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { ProjectModel, ProjectShortInfoModel } from 'Pages/knowledge'

export const projectApi = {
	getAllProjectApi: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ProjectModel>>(`${urls.knowledge.project}`, {
			params,
		})
		return res.data
	},
	getOneProjectApi: async (id: number) => {
		const res = await axiosDS().get<ProjectModel>(`${urls.knowledge.project}/${id}`)
		return res.data
	},
	createOneProjectApi: async (data: ProjectShortInfoModel) => {
		const res = await axiosDS().post<ProjectModel>(`${urls.knowledge.project}`, { data })
		return res.data
	},
	updateOneProjectApi: async (data: ProjectShortInfoModel, id: number) => {
		const res = await axiosDS().patch<ProjectModel>(`${urls.knowledge.project}/${id}`, { data })
		return res.data
	},
	deleteOneProjectApi: async (id: number) => {
		const res = await axiosDS().delete(`${urls.knowledge.project}/${id}`)
		return res.data
	},
	recoverOneProjectApi: async (id: number) => {
		const res = await axiosDS().post(`${urls.knowledge.project}/${id}/recover`)
		return res.data
	},
}
